import { NotFoundPage } from "@productlane/ui"

export function NotFound() {
	return (
		<div className="relative h-full w-full">
			<NotFoundPage path={window.location.href} />
		</div>
	)
}
